import { DefaultQueryParams, httpClient, parseQuery } from '@pascal/pascal-core';
import { environmentBuilder } from '../../core/helpers/environmentBuilder';
import { ApiVersion } from '../../core/constants/apiVersion';
import { ComboKeno10, ComboKeno8, ComboKeno8GameId } from '../../core/constants/appDefaultValues';

class UserService {
  constructor({ url }) {
    this.url = url;
  }

  getBalance(options = { version: ApiVersion.v1 }) {
    const { version } = options;
    const url = `${this.url}/api/${version}/Player/balance`;
    return httpClient.get(url);
  }
}

const { [DefaultQueryParams.GameId]: gameId } = parseQuery(window.location.search);
const gameName = +gameId === ComboKeno8GameId ? ComboKeno8 : ComboKeno10;

const { httpUrl } = environmentBuilder(gameName);

export const userService = new UserService({ url: httpUrl });
